const key='extone.chat-referral.v1';
const uuid=(value:string|null):value is string=>value!==null&&/^[\da-f]{8}-(?:[\da-f]{4}-){3}[\da-f]{12}$/i.test(value);
/** Anonymous analytics input only; never an authentication or transcript credential. */
export function captureChatReferral():string|undefined{
 try{
  if(['/signup','/login'].includes(location.pathname)){
   const values=new URLSearchParams(location.search).getAll('chat_ref');
   if(values.length){
    if(values.length===1&&uuid(values[0]))sessionStorage.setItem(key,values[0].toLowerCase());
    else sessionStorage.removeItem(key);
   }
  }
  const value=sessionStorage.getItem(key);return uuid(value)?value.toLowerCase():undefined;
 }catch{return undefined;}
}
export function clearChatReferral(){try{sessionStorage.removeItem(key);}catch{/* Analytics storage cannot prevent authentication. */}}
